export const bezier = `cubic-bezier(.39,.79,.96,.67)`

export const DAY_LENGTH = 86400000
